/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ScriptModule
 */

/***************************************************************************
 * ------------------------------------------------------------------------
 * Copyright 2020 VMware, Inc.  All rights reserved. VMware Confidential
 * ------------------------------------------------------------------------
*/

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AviPermissionResource } from 'generated-types';
import { DataScriptSetModalComponent } from 'ng/modules/scripts';

export type TDataScriptSetCollection = typeof DataScriptSetCollection;

/**
 * @description DataScriptSet collection
 *
 * @author Aravindh Nagarajan
 */
export class DataScriptSetCollection extends Collection {
    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'vsdatascriptset',
            windowElement: DataScriptSetModalComponent,
            permissionName: AviPermissionResource.PERMISSION_VSDATASCRIPTSET,
            ...args,
        };

        super(extendedArgs);

        this.itemClass_ = this.getAjsDependency_('DataScriptSet');
    }

    /**
     * Modify the config of the Item to be cloned.
     * Uses "-copy" suffix instead of " (copy)" because DataScript names don't allow parentheses.
     * @override
     */
    public modifyClonedConfig(config: any): any {
        config.name = `${config.name}-copy`;

        return config;
    }
}

DataScriptSetCollection.ajsDependencies = [
    'DataScriptSet',
];
